import React from "react";
import Autocomplete from "react-autocomplete";
import { debounce } from "throttle-debounce";

export default class AutocompleteInput extends React.PureComponent {
  state = {
    resultSelected: false,
    searching: false,
    searchResults: [],
    searchValue: "",
  };

  renderAutocompleteInput = (props) => (
    <div>
      <input
        type="text"
        placeholder={this.props.placeholder || "Search"}
        {...props}
      />
    </div>
  );

  renderAutocompleteItem = (item, isHighlighted) => (
    <div
      key={item.key}
      style={{
        background: isHighlighted ? "#f5f5f5" : "white",
        cursor: "pointer",
        padding: "8px 16px",
      }}
    >
      {item.value}
    </div>
  );

  renderAutocompleteMenu = (items, value, style) =>
    items.length < 1 ? (
      <div />
    ) : (
      <div
        style={{ ...style }}
        children={items}
        className="autocomplete-menu"
      />
    );

  search = (event) => {
    const isSearchEvent = !!event;
    this.setState(
      {
        resultSelected: false,
        searching: true,
        searchValue: isSearchEvent
          ? event.target.value
          : this.state.searchValue,
      },
      this.props.debounceSearch && isSearchEvent
        ? this.getSearchResultsDebounced
        : this.getSearchResults,
    );
  };

  getSearchResultsDebounced = debounce(500, () => this.getSearchResults());

  getSearchResults = async () => {
    const searchResults = await this.props.getSearchResults(
      this.state.searchValue,
    );
    this.setState({
      searching: false,
      searchResults,
    });
  };

  selectSearchResult = (resultValue, result) => {
    this.setState(
      {
        resultSelected: true,
        searchResults: [],
        searchValue: resultValue,
      },
      () => {
        this.props.selectSearchResult(result);
      },
    );
  };

  render() {
    const { resultSelected, searching, searchResults, searchValue } =
      this.state;

    return (
      <React.Fragment>
        <Autocomplete
          autoHighlight={false}
          getItemValue={(item) => item.value}
          // inputProps={{
          //     onKeyDown: event => {
          //         if (event.key === 'Enter')
          //             this.getSearchResults();
          //         //Why does this clear out results?
          //     }
          // }}
          items={searchResults}
          onChange={this.search}
          onSelect={this.selectSearchResult}
          renderInput={this.renderAutocompleteInput}
          renderItem={this.renderAutocompleteItem}
          renderMenu={this.renderAutocompleteMenu}
          value={searchValue}
        />
        {searchValue &&
          !searching &&
          !resultSelected &&
          !searchResults.length && (
            <span
              className="error-text"
              style={{ position: "absolute", top: "48px", right: "0px" }}
            >
              No results found
            </span>
          )}
      </React.Fragment>
    );
  }
}
